import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './protal'
import store from '@/store'
import { message } from 'ant-design-vue'
Vue.use(VueRouter)

// 避免到当前位置的冗余导航 (重复触发了同一个路由)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})
export default router
